var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_102_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.9821 0.644685C60.7079 0.556091 66.4008 0.608591 72.0872 0.556091C72.4318 7.25312 74.8402 14.0748 79.7424 18.8097C84.6347 23.6627 91.5549 25.8841 98.288 26.6355V44.2525C91.9782 44.0458 85.6388 42.7333 79.913 40.0164C77.4193 38.8877 75.0962 37.4341 72.8222 35.9477C72.7927 48.7314 72.8747 61.4987 72.7402 74.23C72.399 80.3462 70.381 86.433 66.8241 91.473C61.1016 99.8631 51.1693 105.333 40.9679 105.504C34.7105 105.861 28.4597 104.155 23.1277 101.012C14.2913 95.8009 8.07334 86.2623 7.16772 76.0248C7.05364 73.8567 7.03613 71.6845 7.11522 69.5148C7.90272 61.1903 12.0207 53.2267 18.4126 47.8094C25.6576 41.4995 35.8065 38.4939 45.309 40.2723C45.3976 46.7528 45.1383 53.2267 45.1383 59.7072C40.7972 58.3028 35.7244 58.6966 31.9313 61.3314C29.1562 63.1596 27.059 65.8494 25.9627 68.9866C25.0571 71.2047 25.3163 73.6689 25.3688 76.0248C26.409 83.2042 33.3127 89.2384 40.6824 88.5855C45.5682 88.533 50.2505 85.698 52.7968 81.5472C53.6204 80.0936 54.5424 78.6072 54.5916 76.8977C55.0215 69.0719 54.8508 61.2789 54.9033 53.4531C54.9394 35.8164 54.8508 18.2289 54.9854 0.647966L54.9821 0.644685Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_102_14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 105,
    height: 105,
    fill: "white",
    transform: "translate(0.158936 0.556091)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.d9fbbf7d3fc61f5ca20024692068d89a.svg";
export { ForwardRef as ReactComponent };